export default "__VITE_ASSET__G8DB7QTh__"